import { getError } from "@/utils/helpers";
import StatuteService from "@/services/statute/StatuteService";

export const namespaced = true;

export const state = {
  progress: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_MEMBERS(state, progress) {
    state.progress = progress;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getStatus({ commit }, famId) {
    commit("SET_LOADING", true);

    StatuteService.showStatusStatute(famId)
      .then((response) => {
        commit("SET_MEMBERS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_MEMBERS", []);
  },
};
export const getters = {
  progress: (state) => {
    return state.progress;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
